import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  dividerText: FelaCSS;
  loginMethodsDividerLineAfter: FelaCSS;
  loginMethodsDividerLineBefore: FelaCSS;
  loginMethodsDividerWrapper: FelaCSS;
  otherMethod: FelaCSS;
}

const styles: IStyles = {
  dividerText: {
    textAlign: 'center',
    fontDefault: 14,
  },
  loginMethodsDividerLineAfter: {
    content: '',
    flexGrow: 1,
    background: colors.space40,
    height: '1px',
  },
  loginMethodsDividerLineBefore: {
    content: '',
    flexGrow: 1,
    background: colors.space40,
    height: '1px',
  },
  loginMethodsDividerWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    color: colors.space75,
    gap: spacing[5],
    marginInline: spacing[4],
  },
  otherMethod: {
    alignSelf: 'center',
    width: 'fit-content',
    fontDefault: 16,
    marginTop: 2,
    marginBottom: 6,
  },
};

export default styles;
